import { PJMediaType, PJItem } from '../Teleexpertise/questionTypes/TransmissionPJ/_props'

export function getMediaTypeFromFile(file: File): PJMediaType {
    const mimeType = file.type.toLowerCase()
    if (mimeType.startsWith('image/')) return 'picture'
    if (mimeType.startsWith('video/')) return 'video'
    if (mimeType.includes('pdf') || file.name.toLowerCase().endsWith('.pdf')) return 'document'
    return 'document'
}

export function toObjectUrl(file: File) {
    return URL.createObjectURL(file)
}

export function buildAnswer(items: PJItem[]) {
    return items
}

export const getMediaTypeFromUrl = (url: string): PJMediaType => {
    const path = url.split(/[?#]/)[0].toLowerCase()
    if (/\.(jpe?g|png)$/.test(path)) return 'picture'
    if (/\.(mp4|mov)$/.test(path)) return 'video'
    return 'document'
}

export const restoreItemFromUrl = (url: string, index: number): PJItem => {
    const fileName = decodeURIComponent(url.split(/[?#]/)[0].split('/').pop() ?? '').replace(/^.*?-PJ-\d+-/, '')
    const name = fileName || `piece-jointe-${index + 1}`

    return {
        id: `${url}-${index}`,
        url: '',
        remoteUrl: url,
        name,
        mediaType: getMediaTypeFromUrl(url),
    } as PJItem
}

export const toPJAnswerValue = (value: any) => {
    if (value && typeof value === 'object' && ('remoteUrl' in value || 'file' in value)) {
        return value.remoteUrl ?? value.url
    }
    return value
}

export function restoreItemsFromInitialValue(initialValue: any): PJItem[] {
    if (typeof initialValue === 'string' && initialValue) {
        initialValue = [initialValue]
    }
    if (!initialValue || !Array.isArray(initialValue)) {
        return []
    }
    const restored = (initialValue as (PJItem | string)[]).reduce((acc: PJItem[], item, index) => {
        if (typeof item === 'string') {
            acc.push(restoreItemFromUrl(item, index))
        } else if (item?.remoteUrl && !(item.file instanceof Blob)) {
            acc.push({ ...item, url: '' })
        } else if (item?.file instanceof Blob) {
            // old drafts stored PJItem as JSON: `file` became `{}` and can't be restored
            acc.push({
                ...item,
                url: URL.createObjectURL(item.file),
            })
        }
        return acc
    }, [] as PJItem[])
    return restored
}
